<template lang="pug">
div
  div.container-banner( v-for="(page, i) in educationList" :style="{ background: active === 0 ? 'linear-gradient(163.88deg, #FFEF9E 16.48%, #77BEF4 110.02%)': '#F6DDD4'}" :key="i" v-show="i === active" )
    .img
      img( :src="require(`@/assets/bannerLogo/${page.img}`)" )
    .text
      div.text-header.text-32 {{ page.header }}
      div.mt-8.text-body.text-20 {{ page.body }}
      .dots.mt-3
        span.dot(
          v-for="(dot, index) in educationList"
          :key="index"
          :class="{ active: index === active }"
          @click="active = index"
        )
      div.button-container
        button.button.cancel( @click="goToMainPage" ) Пропустить
        button.button.next.ml-6( @click="goNext" ) Дальше
</template>
<script>

export default {
  name: 'CybershiledBellic',

  data() {
    return {
      active: 0,
      educationList: [
        {
          page: 0,
          header: "Киберщит Беллика",
          body: "Защищай свои данные! Не передавай никому PIN-коды, пароли и данные карты. Даже если просят «друзья» онлайн!",
          img: "data-protection.svg"
        },
        {
          page: 1, 
          header: "Копилка мечты",
          body: "Планируй расходы, копи на важное и не трать всё сразу. Каждая монетка приближает тебя к мечте!",
          img: "watch-temper.svg"
        }
      ]
    }
  },

  methods: {
    goNext() {
      if(this.active == 0) {
        this.active = this.active + 1
        return
      }
      
      if(this.active == 1) this.goToMainPage()
    },

    goToMainPage() {
      this.$router.push({path: '/home'})
      
    }
  }
}
</script>
<style scoped>
.container-banner {
  background: #FFEF9E;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.img {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
  padding: 10px 0;
}

.img img {
  max-height: 40vh;
  max-width: 90%;
  object-fit: contain;
}
.text {
  background: #FFFFFF;
  border-top-left-radius: 120px;
  border-top-right-radius: 120px;
  padding: 40px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.text-header {
  text-align: center;
}
.text-body {
  margin-top: 12px;
  text-align: center;
}
.education {
  margin-top: 34px;
  color: #5365E5;
}
.button-container {
  margin-top: 20px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  padding-right: 20px;
  padding-left: 20px;
  justify-content: center;
}
button {
  height: 78px;
  width: 160px;
  border-radius: 60px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}
.cancel {
  background: #FDF1F1;
  color: #F6514C;
}
.next {
  color: #FFFFFF;
  background: #F6514C;
}
.dots {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: 20px 0;
}
.dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #999;
  transition: all 0.3s ease;
}
.dot.active {
  width: 12px;
  height: 5px;
  border-radius: 8px;
  background-color: #000;
}
</style>
